var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import DeviceProfileV2, { DeviceProfileTypeKeys } from '@square/dashboard-data/models/device-profiles-v2/device-profile-v2';
import { DeviceProfileType } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/shared/device_profile_type';
import { FNBKioskDiningOption } from '@square/dashboard-data/models/device-profiles-v2/settings/fnb-kiosk-settings';
let KioskProfilesService = (_dec = service('device-profiles-v2/device-profile-v2'), (_class = class KioskProfilesService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "deviceProfileV2Service", _descriptor2, this);
  }
  async createProfileWithDefaultSettings(defaultSettingName, isShared) {
    const defaultKioskProfile = await this.deviceProfileV2Service.getDefaultProfile(DeviceProfileType.FNBKIOSK);
    const defaultDeviceProfile = DeviceProfileV2.fromProto(defaultKioskProfile.deviceProfile);
    const defaultDiningOptions = await this.getDefaultDiningOptions();
    if (isPresent(defaultDeviceProfile.profileSettings.fnbKiosk)) {
      defaultDeviceProfile.profileSettings.fnbKiosk.set('diningOptions', defaultDiningOptions);
    }
    if (defaultKioskProfile.deviceProfile) {
      const deviceProfile = DeviceProfileV2.create({
        name: defaultSettingName,
        type: DeviceProfileTypeKeys.FNBKIOSK,
        shared: isShared,
        profileSettings: defaultDeviceProfile.profileSettings
      });
      const profile = await this.deviceProfileV2Service.deprecatedCreateDeviceProfile(deviceProfile);
      return profile;
    } else {
      const profile = await this.createDefaultSettings(defaultSettingName, isShared);
      return DeviceProfileV2.fromProto(profile);
    }
  }
  updateDiningOptions(deviceProfile, diningOptions) {
    const newDiningOptions = diningOptions.map((diningOption, i) => ({
      diningOptionId: diningOption.id,
      kioskOrdinal: i
    }));
    const updatedProfile = deviceProfile;
    updatedProfile.fnbKioskSettings.fnbKiosk.diningOptions = newDiningOptions;
    this.deviceProfileV2Service.updateDeviceProfile(updatedProfile);
  }

  /**
   * Retrieve dining option for default kiosk setting.
   * @returns The first two dining options if there are more than two or one dining option if there is only one
   */
  async getDefaultDiningOptions() {
    const diningOptions = await this.store.findAll('dining-option');
    let filteredDiningOptions = diningOptions.toArray().filter(diningOption => diningOption.globallyEnabled || diningOption.disabledUnits.length === 0);
    if (filteredDiningOptions.length > 1) {
      // Use first two dining options as default kiosk dining option settings values
      filteredDiningOptions = filteredDiningOptions.sort((diningOptionA, diningOptionB) => diningOptionA.ordinal - diningOptionB.ordinal).slice(0, 2);
    }
    return filteredDiningOptions.map((diningOption, i) => FNBKioskDiningOption.create({
      diningOptionId: diningOption.id,
      kioskOrdinal: i
    }));
  }
  async createDefaultSettings(defaultSettingName, isShared) {
    const profile = await this.deviceProfileV2Service.createDefaultDeviceProfile(defaultSettingName, DeviceProfileType.FNBKIOSK, undefined, isShared);
    return profile;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "deviceProfileV2Service", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { KioskProfilesService as default };